var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("skp-breadcrumbs", {
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("table", { staticClass: "create_table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBJECT"))),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable w100" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notice.title,
                        expression: "notice.title"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: {
                      type: "text",
                      placeholder: "Subject",
                      maxlength: "90"
                    },
                    domProps: { value: _vm.notice.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.notice, "title", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  _vm._s(_vm.$t("FIELD.NOTICE.TARGET")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("fieldset", { staticClass: "ui_table" }, [
                  _c("span", { staticClass: "radio_item" }, [
                    false
                      ? _c("label", { staticClass: "radiobox-wrap" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.notice.distTarget,
                                expression: "notice.distTarget"
                              }
                            ],
                            attrs: { type: "radio", name: "rdo1", value: "G" },
                            domProps: {
                              checked: _vm._q(_vm.notice.distTarget, "G")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(_vm.notice, "distTarget", "G")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "radio-icon" }),
                          _vm._v(" "),
                          _c("em", [
                            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.GLOBAL")))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", { staticClass: "radiobox-wrap" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.notice.distTarget,
                            expression: "notice.distTarget"
                          }
                        ],
                        attrs: { type: "radio", name: "rdo1", value: "S" },
                        domProps: {
                          checked: _vm._q(_vm.notice.distTarget, "S")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.notice, "distTarget", "S")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "radio-icon" }),
                      _vm._v(" "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "global_item" },
                    [
                      _vm.notice.distTarget === "S" &&
                      _vm.selectedSubsidiaryList.length > 0
                        ? _c("fragment", [
                            _c(
                              "em",
                              {
                                staticClass: "tooltip_box",
                                attrs: { name: "selectSubsidiary" }
                              },
                              [
                                _vm._v(
                                  "\n                                        (\n                                        " +
                                    _vm._s(_vm.selectedSubsidiaryList.length) +
                                    "\n                                        "
                                ),
                                _vm.selectedSubsidiaryList.length > 1
                                  ? [_vm._v("Subsidiaries")]
                                  : [_vm._v("Subsidiary")],
                                _vm._v(
                                  "\n                                        )\n                                        "
                                ),
                                _c("i", { staticClass: "tooltip" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedSubsidiaryList.join(", ")
                                    )
                                  )
                                ])
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notice.distTarget === "S"
                        ? _c(
                            "a",
                            {
                              staticClass: "ico_write_global",
                              attrs: { href: "javascript:" },
                              on: { click: _vm.globalTargetPop }
                            },
                            [
                              _c("span", { staticClass: "sr_only" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("BUTTON.KNOWLEDGE.GLOBALEDIT"))
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("tr", [
              _vm._m(2),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "radio_item" }, [
                  _c("label", { staticClass: "radiobox-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notice.popupYN,
                          expression: "notice.popupYN"
                        }
                      ],
                      attrs: { type: "radio", name: "rdo2", value: "Y" },
                      domProps: { checked: _vm._q(_vm.notice.popupYN, "Y") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.notice, "popupYN", "Y")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "radio-icon" }),
                    _vm._v(" "),
                    _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.YES")))])
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "radiobox-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notice.popupYN,
                          expression: "notice.popupYN"
                        }
                      ],
                      attrs: { type: "radio", name: "rdo2", value: "N" },
                      domProps: { checked: _vm._q(_vm.notice.popupYN, "N") },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.notice, "popupYN", "N")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "radio-icon" }),
                    _vm._v(" "),
                    _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.NO")))])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.GLOBAL.DESCRIPTION")) +
                    "\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  !_vm.isLoading
                    ? _c("cross-editor", {
                        staticClass: "text_textarea w100",
                        attrs: {
                          editorId: "noticeEditor",
                          editorData: _vm.notice.description
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ATTACHMENT")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("innorix-upload", {
                    attrs: {
                      id: _vm.getUploadId,
                      name: _vm.getUploadId,
                      uploadId: _vm.getUploadId,
                      onlyUpload: _vm.onlyUpload,
                      attachList: _vm.attachFileSeq
                    },
                    on: { files: _vm.setAttachFiles }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }, [
          _c(
            "a",
            {
              staticClass: "btn_white",
              attrs: { href: "javascript:", title: "" },
              on: { click: _vm.onListClick }
            },
            [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn_right" }, [
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "javascript:", title: "" },
                on: { click: _vm.onRegisterClick }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REGISTER")))]
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [
        _vm._v("Period\n                        "),
        _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
      ]),
      _vm._v(" "),
      _c("td", { attrs: { "data-input-type": "date" } }, [
        _c("fieldset", { staticClass: "ui_fieldset" }, [
          _c("label", { staticClass: "date-wrap" }, [
            _c("input", {
              staticClass: "date_input w100",
              attrs: {
                id: "fromDate",
                type: "text",
                maxlength: "10",
                placeholder: "From Date",
                readonly: ""
              }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "in_btn",
                attrs: { href: "javascript:", id: "icoFromDate" }
              },
              [
                _c("i", { staticClass: "ico_date" }),
                _vm._v(" "),
                _c("span", { staticClass: "sr_only" }, [
                  _vm._v("Open Calendar")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "from-picker-container" } }),
          _vm._v(" "),
          _c("em", { staticClass: "txt_space" }),
          _vm._v(" "),
          _c("label", { staticClass: "date-wrap" }, [
            _c("input", {
              staticClass: "date_input w100",
              attrs: {
                id: "toDate",
                type: "text",
                maxlength: "10",
                placeholder: "To Date",
                readonly: ""
              }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "in_btn",
                attrs: { href: "javascript:", id: "icoToDate" }
              },
              [
                _c("i", { staticClass: "ico_date" }),
                _vm._v(" "),
                _c("span", { staticClass: "sr_only" }, [
                  _vm._v("Open Calendar")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticStyle: { "margin-top": "-1px" },
            attrs: { id: "to-picker-container" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Popup\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35104853", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35104853","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/other/NoticeCreate.vue
// module id = ODW3
// module chunks = 0